import { IfGateConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';
import { getIfRuleTourSteps } from '../component-tours';

export function getIfGateTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as IfGateConfig;

	return [
		{
			id: 'add-destination',
			selector: '[data-tour="add-destination"]',
			content: 'This is used to add a destination/rule to the If Gate task to be configured.',
		},
		...(config.rules.length > 0
			? [
					{
						id: 'rule-destination',
						selector: '[data-tour="rule-destination"]',
						content: 'This is used as the task that will execute if the rule is truthy.',
					},
					{
						id: 'delete-if-statement',
						selector: '[data-tour="delete-if-statement"]',
						content: 'Removes the entire if statement along with all of its rules and rule groups.',
					},
					...getIfRuleTourSteps({ defaultStyles, hasIfRules: config.rules.length > 0 }),
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
